<script>
import setting from '@/setting.js'
import common from '@/common.js'
import API from '@/api.js'
import Calculate from '@/calculate.js'
import Seasonpicker from '@/components/utility/Seasonpicker'
import {mapGetters} from "vuex"

export default {
    name: 'ThreeSearch',
    mixins: [Seasonpicker],
    props: ['initMode', 'mode', 'atBatBalls', 'allBalls', 'playing', 'nowID', 'colors', 'savedBalls', 'enableMultiPos', 'baseBallIndex', 'getBallText', 'searchModalFlg', 'currentSavedBallsId', 'searchModalType', 'savedStandardBall', 'currentSavedStandardBallId'],
    emits: ['get-saved-standard-balls', 'update-all', 'close-search-modal', 'get-saved-balls', 'loading-off', 'loading-on'],
    data() {
        return {
            year: this.$moment().year(),
            setting,
            userAccountPitcherID: null,             // ユーザーアカウントに登録された選手ID
            userAccountPositionPitcher: false,      // ユーザーアカウントに登録された選手IDが投手か
            userAccountPermission3dMyTeam: true,    // 自チームの他投手データ閲覧権限
            userAccountPermission3dOtherTeam: true,   // 他チームの投手データ閲覧権限
            searchState: 0,
            /* 検索条件v-model */
            formSelectTeam: setting.pulldownTeamList[0],
            formSelectPlayer: '',
            formSelectBall: '',
            formSelectDate: ['', ''],
            formSelectStadium: '',
            formSelectType: 0,
            /* 検索結果フィルター */
            filterSelectDate: '',
            filterSelectHittype: '',
            filterSelectResult: '',
            filterSelectVsTeam: '',
            filterSelectVsBatter: '',
            filterSelectAtBat: '',
            /* */
            formDategameSchedule: {},
            savedBasllsId: [],
            savedStandardBasllsId: [],
            minDate: '2015-05-01',
            maxDate: window.moment(new Date()).format('YYYY-MM-DD'),
            isValidateList: {
                player: false,
                date: false
            },
            isValidate: true,
            formTeamList: null,
            listOfTeams: {},
            sortedListOfTeams: [],  // プルダウン用
            listOfRosters: {},
            sortedListOfStadiums: [],
            pitchingDefaultResultList: {},
            temp_kinds: [
                'ストレート',
                'カーブ',
                'ストレート',
                'スライダー',
                'チェンジアップ'
            ],
            opened: true,
            priority: [
                'Fastball',
                'ChangeUp',
                'Curveball',
                'Cutter',
                'KnuckleBall',
                'Sinker',
                'Slider',
                'Splitter'
            ],
            sortedArray: {
                'Fastball': [],
                'ChangeUp': [],
                'Curveball': [],
                'Cutter': [],
                'KnuckleBall': [],
                'Sinker': [],
                'Slider': [],
                'Splitter': []
            },
            pitchTypeName: {
                'Fastball': '速球',
                'ChangeUp': 'チェンジアップ',
                'Curveball': 'カーブ',
                'Cutter': 'カットボール',
                'KnuckleBall': 'ナックル',
                'Sinker': 'シンカー',
                'Slider': 'スライダー',
                'Splitter': 'スプリッター'
            },
            typesOf3DSearchKorBB: {
                'Strikeout': {
                    name: '三振'
                },
                'StrikeoutSwinging': {
                    name: '三振（空振り）'
                },
                'StrikeoutCalled': {
                    name: '三振（見逃し）'
                },
                'Walk': {
                    name: '四球'
                }
            },
            typesOf3DSearchPitchCall: {
                'StrikeSwinging': {
                    name: '空振ストライク'
                },
                'StrikeSwingingZone': {
                    name: '空振ストライク（ゾーン内）'
                },
                'StrikeSwingingO-Zone': {
                    name: '空振ストライク（ゾーン外）'
                },
                'StrikeCalled': {
                    name: '見逃しストライク'
                },
                'FoulBall': {
                    name: 'ファール'
                },
                'BallCalled': {
                    name: 'ボール'
                },
                'BallCalledHitByPitch': {
                    name: 'デッドボール'
                }
            },
            filterInPlayList: [
                'Sacrifice',
                'FieldersChoice',
                'Single',
                'Double',
                'Triple',
                'HomeRun',
                'Out',
                'Error',
                'FoulBall'
            ],
            filterIndexArray: [],
            filteredDataArray: [],
            defaultBalls: [],
            sortMode: 0,
            filterListFlg: false,
            mostFastBall: {},
            ballsOfCompare: [],
            // compare sort
            compareSortNumber: 0,
            compareSortList: [
                'pitchno',
                'RelSpeed',
                'RelSpeed_Per',
                'SpinRate',
                'Rifle',
                'w_sin_a',
                'InducedVertBreak',
                'HorzBreak',
                'RelHeight',
                'RelSide'
            ],
            // 0 昇順 1 降順
            compareSortListStatus: 0,
            // 検索結果球数
            allBallNumber: 0,
            playerTeam: '',
            listOfTeamsLS: this.$copy(this.$store.getters.listOfTeams),
            filteredRoster: []
        }
    },
    computed: {
        ...mapGetters(['listOfStadiums','userAccount']),
        // 検索のチーム名が選択可能か
        formSelectTeamSelectable () {
            if (this.sortedListOfTeams === undefined) {
                return false
            }
            return this.sortedListOfTeams.length === 1
        },
        // 検索の投手名が選択可能か
        formSelectPlayerSelectable () {
            return !this.$p.get(this.formSelectTeam)
        },
        currentBallNumber() {
            return this.filteredBalls.length
        },
        // 検索結果の全球を元に、フィルターで条件を絞り込む
        filteredBalls () {
            if (this.defaultBalls.length === 0) {
                return []
            }
            // 試合
            if (this.formSelectType === 0) {
                const {
                    filterSelectDate: date,
                    formSelectBall: ball,
                    filterSelectHittype: hitType,
                    filterSelectResult: result,
                    filterSelectVsTeam: vsTeam,
                    filterSelectVsBatter: vsBatter,
                    filterSelectAtBat: atBat
                } = this

                return this.defaultBalls.filter((d) => {
                    const data = d.data
                    if (date && date !== data['Date']) return false
                    if (ball && ball !== data['AlphaTaggedPitchType']) return false
                    if (hitType && hitType !== data['HitType'].id) return false

                    if (result) {
                        const rid = data.result.id
                        if (result === 'BallCalled') {
                            if (rid !== 'BallCalled' && rid !== 'BallCalledHitByPitch' && rid !== 'Walk') return false
                        } else if (result === 'StrikeSwinging') {
                            if (rid !== 'StrikeSwingingZone' && rid !== 'StrikeSwingingO-Zone') return false
                        } else if (result === 'Strikeout') {
                            if (rid !== 'Strikeout' && rid !== 'StrikeoutSwinging' && rid !== 'StrikeoutCalled') return false
                        } else if (result !== rid) {
                            return false
                        }
                    }

                    if (vsTeam && vsTeam !== data['BatterTeamId']) return false
                    if (vsBatter && vsBatter !== data['BatterId']) return false
                    if (atBat && atBat !== data['AtBat']) return false

                    return true
                })
            }
            // ブルペン
            if (this.formSelectType === 1) {
                let tempBalls = this.formSelectBall
                    ? this.defaultBalls.filter(d => d.data['AlphaTaggedPitchType'] === this.formSelectBall)
                    : [...this.defaultBalls]

                const sortKey = this.compareSortList[this.compareSortNumber]
                const isDesc = this.compareSortListStatus !== 0

                // pitchno sort is always applied first in original code
                tempBalls.sort((a, b) => {
                    const valA = a.data[sortKey]
                    const valB = b.data[sortKey]

                    if (valA < valB) return isDesc ? 1 : -1
                    if (valA > valB) return isDesc ? -1 : 1

                    // secondary sort by pitchno
                    const pA = a.data['pitchno']
                    const pB = b.data['pitchno']
                    if (pA < pB) return isDesc ? 1 : -1
                    if (pA > pB) return isDesc ? -1 : 1

                    return 0
                })
                return tempBalls
            }
            return []
        },
        // フィルタープルダウン項目 試合日
        pitchingDateList () {
            if (this.defaultBalls.length === 0) return []
            const set = new Set()
            const tempBalls = this.getTempBalls('Date')
            tempBalls.forEach(d => set.add(d.data['Date']))

            // 抽出されたデータが0件でもしプルダウン候補に選択されている値が無い場合、空になってしまわないようその項目を追加
            if (this.filteredBalls.length === 0 && this.filterIndexArray.some(d => d.id === 'Date')) {
                set.add(this.filterSelectDate)
            }
            return Array.from(set)
        },
        // フィルタープルダウン項目 球種
        pitchingTypeList () {
            if (this.defaultBalls.length === 0) return []
            const set = new Set()
            const tempBalls = this.getTempBalls('AlphaTaggedPitchType')
            tempBalls.forEach(d => set.add(d.data['AlphaTaggedPitchType']))

            // 抽出されたデータが0件でもしプルダウン候補に選択されている値が無い場合、空になってしまわないようその項目を追加
            if (this.filteredBalls.length === 0 && this.filterIndexArray.some(d => d.id === 'AlphaTaggedPitchType')) {
                set.add(this.formSelectBall)
            }

            // 指定順に並び替え
            return this.setting.listOfLegend.filter(d => set.has(d))
        },
        // フィルタープルダウン項目 打球
        pitchingHitTypeList () {
            if (this.defaultBalls.length === 0) return []
            const set = new Set()
            const tempBalls = this.getTempBalls('HitType')

            if (this.filterSelectResult === '' || this.filterInPlayList.indexOf(this.filterSelectResult) > -1) {
                // 判定結果が空なら全てを表示
                tempBalls.forEach(d => set.add(d.data['HitType'].id))
            } else {
                // 判定結果が三振等InPlayでなければ空にする
                return []
            }

            // 抽出されたデータが0件でもしプルダウン候補に選択されている値が無い場合、空になってしまわないようその項目を追加
            if (this.filteredBalls.length === 0 && this.filterIndexArray.some(d => d.id === 'HitType')) {
                set.add(this.filterSelectHittype)
            }

            return this.setting.listOfHitType.filter(d => set.has(d))
        },
        // フィルタープルダウン項目 打者結果
        pitchingResultList () {
            if (this.defaultBalls.length === 0) return []
            const set = new Set()
            const tempBalls = this.getTempBalls('result')

            if (this.filterSelectHittype === '') {
                // 打球のセレクタが空（未設定）であれば全てを追加
                tempBalls.forEach(d => set.add(d.data.result.id))
            } else {
                // 打球に値があれば三振などを除外
                tempBalls.forEach((d) => {
                    if (this.filterInPlayList.indexOf(d.data.result.id) > -1) {
                        set.add(d.data.result.id)
                    }
                })
            }
            // 抽出されたデータが0件でもしプルダウン候補に選択されている値が無い場合、空になってしまわないようその項目を追加
            if (this.filteredBalls.length === 0 && this.filterIndexArray.some(d => d.id === 'result')) {
                set.add(this.filterSelectResult)
            }
            // 空振り（ゾーン外、ゾーン内）があれば空振りを追加
            if (set.has('StrikeSwingingZone') || set.has('StrikeSwingingO-Zone')) {
                set.add('StrikeSwinging')
            }
            // 三振（空振り、見逃し）があれば三振を追加
            if (set.has('StrikeoutSwinging') || set.has('StrikeoutCalled')) {
                set.add('Strikeout')
            }

            return Object.keys(this.pitchingDefaultResultList).filter(d => set.has(d))
        },
        // フィルタープルダウン項目 対戦チーム
        pitchingVsTeamList () {
            if (this.defaultBalls.length === 0) return []
            const set = new Set()
            const tempBalls = this.getTempBalls('BatterTeamId')
            tempBalls.forEach(d => set.add(d.data['BatterTeamId']))

            // 抽出されたデータが0件でもしプルダウン候補に選択されている値が無い場合、空になってしまわないようその項目を追加
            if (this.filteredBalls.length === 0 && this.filterIndexArray.some(d => d.id === 'BatterTeamId')) {
                set.add(this.filterSelectVsTeam)
            }

            const sortedList = this.setting.pulldownTeamList.filter(d => set.has(d))

            // NPB12球団以外があれば追加
            set.forEach((teamId) => {
                if (this.setting.pulldownTeamList.indexOf(teamId) === -1) {
                    sortedList.push(teamId)
                }
            })
            return sortedList
        },
        // フィルタープルダウン項目 打者
        pitchingVsBatterList () {
            if (this.defaultBalls.length === 0 || this.filterSelectVsTeam === '') {
                return []
            }
            const set = new Set()
            const tempList2 = []
            const tempBalls = this.getTempBalls('BatterId')

            tempBalls.forEach((d) => {
                const batterId = d.data['BatterId']
                if (!set.has(batterId) && this.filterSelectVsTeam === d.data['BatterTeamId']) {
                    set.add(batterId)
                    tempList2.push({
                        id: batterId,
                        name: d.data['BatterName']
                    })
                }
            })

            // 抽出されたデータが0件でもしプルダウン候補に選択されている値が無い場合、空になってしまわないようその項目を追加
            if (this.filteredBalls.length === 0 && this.filterIndexArray.some(d => d.id === 'BatterId')) {
                // Since we don't have the batter name easily available here if it's missing from current tempBalls,
                // we might need to find it from defaultBalls or just use ID.
                // But normally it should be in defaultBalls.
                const batterId = this.filterSelectVsBatter
                if (!set.has(batterId)) {
                    const originalBall = this.defaultBalls.find(b => b.data['BatterId'] === batterId)
                    tempList2.push({
                        id: batterId,
                        name: originalBall ? originalBall.data['BatterName'] : batterId
                    })
                }
            }
            return tempList2
        },
        // フィルタープルダウン項目 打席
        pitchingVsAtBatList () {
            if (this.defaultBalls.length === 0) return []
            const set = new Set()
            const tempBalls = this.getTempBalls('AtBat')
            tempBalls.forEach(d => set.add(d.data['AtBat']))

            // 抽出されたデータが0件でもしプルダウン候補に選択されている値が無い場合、空になってしまわないようその項目を追加
            if (this.filteredBalls.length === 0 && this.filterIndexArray.some(d => d.id === 'AtBat')) {
                set.add(this.filterSelectAtBat)
            }

            return Array.from(set).sort((a, b) => {
                if (a === '-') return -1
                if (b === '-') return 1
                if (a < b) return -1
                if (a > b) return 1
                return 0
            })
        }
    },
    watch: {
        pitchingVsBatterList(v) {
            if (v.length === 0) {
                this.filterSelectVsBatter = ''
            }
        },
        // 条件設定
        formSelectTeam (val) {
            // 選択されたチームをdatepickerに送る
            this.playerTeam = val

            if (val === this.userAccount.my_team) {
                if (this.userAccountPositionPitcher) {
                    // 自チームが指定され、かつピッチャーであれば自身をデフォルト表示
                    this.formSelectPlayer = this.userAccountPitcherID
                    this.checkSelectPlayer()
                } else {
                    // 自チームが設定しなおされたらクリア
                    this.formSelectPlayer = ''
                    this.formSelectDate = ['', '']
                }
            } else {
                // 他チームが設定されたらクリア
                this.formSelectPlayer = ''
                this.formSelectDate = ['', '']
                this.filteredRoster = []
            }
            this.getRosterList(val)
        },
        formSelectPlayer (val) {
            if (this.formSelectTeam && val) {
                // チームと選手両方が設定されていれば、その選手の登板試合を取得
                this.getGameList()
            } else if (!val) {
                this.formSelectDate = ['', '']
            }
        },
        formSelectDate: 'checkSelectDate',
        // 検索結果
        filterSelectVsTeam () {
            this.filterSelectVsBatter = ''
            this.setFilterIndexArray('BatterTeamId', this.filterSelectVsTeam)
        },
        filterSelectDate () {
            this.setFilterIndexArray('Date', this.filterSelectDate)
        },
        formSelectBall () {
            this.setFilterIndexArray('AlphaTaggedPitchType', this.formSelectBall)
        },
        filterSelectHittype () {
            this.setFilterIndexArray('HitType', this.filterSelectHittype)
        },
        filterSelectResult () {
            this.setFilterIndexArray('result', this.filterSelectResult)
        },
        filterSelectVsBatter () {
            this.setFilterIndexArray('BatterId', this.filterSelectVsBatter)
        },
        filterSelectAtBat () {
            this.setFilterIndexArray('AtBat', this.filterSelectAtBat)
        }
    },
    mounted() {
        // 表示可能範囲の確認
        // 選手ID等の登録があるか
        if (this.userAccount.additional !== null) {
            // 紐付けられた選手ID
            if (this.userAccount.additional.player_id !== undefined && this.userAccount.additional.player_id !== '') {
                this.userAccountPitcherID = this.userAccount.additional.player_id
            }
            // 紐付けられた選手IDがある場合、それが投手かどうかを判定
            if (this.userAccountPitcherID !== null) {
                let position = this.$p.get(this.userAccount.additional.my_team)[this.userAccountPitcherID].position
                if (this.userAccountPitcherID !== null && ['pitcher','投手'].includes(position)) {
                    this.userAccountPositionPitcher = true
                }
            }
            // 自チームほか投手の投球データの閲覧権限（0は不可）
            if (this.userAccount.additional.permission_3d_my_team === '0') {
                this.userAccountPermission3dMyTeam = false
            }
            // 他チーム投手の投球データの閲覧権限（0は不可）
            if (this.userAccount.additional.permission_3d_other_team === '0') {
                this.userAccountPermission3dOtherTeam = false
            }
        }
        // 打者結果のデフォルトリストを作成
        Object.keys(setting.typesOfPlayResult).forEach((d) => {
            this.pitchingDefaultResultList[d] = setting.typesOfPlayResult[d]
        })
        Object.keys(this.typesOf3DSearchKorBB).forEach((d) => {
            this.pitchingDefaultResultList[d] = this.typesOf3DSearchKorBB[d]
        })
        Object.keys(this.typesOf3DSearchPitchCall).forEach((d) => {
            this.pitchingDefaultResultList[d] = this.typesOf3DSearchPitchCall[d]
        })
        this.getTeamList()
        this.$nextTick(() => {
            const el = this.$el.nodeType === 1 ? this.$el : (this.$el.parentElement || document.body)
            const resultWrapper = el.querySelector('.searchWrapper.result')
            if (resultWrapper) {
                resultWrapper.addEventListener('touchstart', (event) => {
                    if (event.touches.length > 1) {
                        event.preventDefault()
                    }
                }, { passive: false })
            }
        })
    },
    methods: {
        invalidPinch (e) {
            e.preventDefault()
        },
        closeSearchModal () {
            this.$emit('close-search-modal')
        },
        loadingOn (message) {
            this.$emit('loading-on', message)
        },
        loadingOff () {
            this.$emit('loading-off')
        },
        messageModalOn (msg) {
            this.$root.$emit('messageModalOn', msg)
        },
        noSelectedPlayer () {
            this.$root.$emit('messageModalOn', '投手を選択してください')
        },
        // ブルペン検索結果のソート
        changeCompareSortNumber (num) {
            if (this.compareSortNumber === num) {
                this.compareSortListStatus = (this.compareSortListStatus === 0) ? 1 : 0
            } else {
                this.compareSortListStatus = 0
            }
            this.compareSortNumber = num
        },
        // 検索画面のチームプルダウン用一覧を生成
        getTeamList () {
            this.sortedListOfTeams = []
            setting.pulldownTeamList.forEach((d) => {
                this.$set(this.listOfTeams, d, this.listOfTeamsLS[d])
            })
            // プルダウン用に並び替え
            if (this.userAccountPermission3dOtherTeam) {
                // 他チームの参照権限がある
                this.setting.pulldownTeamList.forEach((list) => {
                    Object.keys(this.listOfTeams).forEach((list2) => {
                        if (list === list2) {
                            let obj = this.$copy(this.listOfTeams[list2])
                            obj.teamID = list2
                            this.sortedListOfTeams.push(obj)
                        }
                    })
                })
                this.formSelectTeam = this.userAccount.my_team
            } else {
                // 他チームの参照権限がない
                let obj = this.$copy(this.listOfTeams[this.userAccount.my_team])
                obj.teamID = this.userAccount.my_team
                this.sortedListOfTeams.push(obj)
                this.formSelectTeam = this.userAccount.my_team
            }
            this.changedYear(this.year)
        },
        // フィルターの条件が変わったらプルダウン用のデータを作成する
        setFilterIndexArray (id, val) {
            // console.log('setFilterIndexArray', id, val)
            let filterIndexArrayIndex = -1
            this.filterIndexArray.forEach((obj, i) => {
                if (obj.id === id) {
                    filterIndexArrayIndex = i
                }
            })
            if (filterIndexArrayIndex === -1) {
                // フィルターとして登録されていなければ追加
                let obj = {
                    id: id,
                    val: val
                }
                this.filterIndexArray.push(obj)
            } else {
                // すでに登録されている場合
                if (val === '') {
                    this.filterIndexArray.splice(filterIndexArrayIndex, 1)
                } else {
                    this.filterIndexArray[filterIndexArrayIndex] = {
                        id: id,
                        val: val
                    }
                }
            }
            this.filteredDataArray = []
            // filterIndexArrayに登録された条件の数だけデータの配列を作る
            this.filterIndexArray.forEach((d, index) => {
                this.filteredDataArray.push([])
                let tempBalls = []
                if (index === 0) {
                    // 0番目なら全データ
                    tempBalls = [].concat(this.defaultBalls)
                } else {
                    // 1番目以降なら直前のデータを使う
                    tempBalls = [].concat(this.filteredDataArray[(index - 1)])
                }
                // filterIndexArrayのindex番目に追加した項目で絞り込まれたデータがfilteredDataArrayのindex番目に配列として追加されていく
                tempBalls.forEach((d2) => {
                    // console.log(d.id , d2['data'][d.id], d.val)
                    if (d.id === 'result' || d.id === 'HitType') {
                        if (d2['data'][d.id].id === d.val) {
                            this.filteredDataArray[index].push(d2)
                        }
                    } else {
                        if (d2['data'][d.id] === d.val) {
                            this.filteredDataArray[index].push(d2)
                        }
                    }
                })
            })
        },
        // プルダウン用にフィルタリングされた球の配列を返す
        getTempBalls (keyStr) {
            let index = -1
            let tempBalls
            this.filterIndexArray.forEach((d, filterIndexArrayIndex) => {
                // filterIndexArrayに追加されている項目かチェック
                if (d.id === keyStr) {
                    index = filterIndexArrayIndex
                }
            })
            if (index === -1) {
                // filterIndexArrayにない
                if (this.filterIndexArray.length > 0) {
                    // filterIndexArrayが空でなければfilteredDataArrayの最後の配列を渡す
                    tempBalls = [].concat(this.filteredDataArray[(this.filteredDataArray.length - 1)])
                } else {
                    // 空なら全データを渡す
                    tempBalls = [].concat(this.defaultBalls)
                }
            } else if (index === 0) {
                // 1番目に追加された項目なら全データを渡す
                tempBalls = [].concat(this.defaultBalls)
            } else {
                // 上記以外なら該当する項目の一つ前の配列を渡す
                tempBalls = [].concat(this.filteredDataArray[(index - 1)])
            }
            return tempBalls
        },
        // 選択可能なチームの出場投手プルダウン用一覧を生成
        getRosterList (teamID) {
            const players = this.$p.get(teamID)
            if (teamID === this.userAccount.my_team && !this.userAccountPermission3dMyTeam) {
                // 自チームが指定されており、かつ自チーム他の閲覧権限がない
                if (this.userAccountPositionPitcher) {
                    // ピッチャーであれば自分のみ表示する
                    this.formSelectPlayer = this.userAccountPitcherID
                    this.checkSelectPlayer()
                }
            }
            // teamIDが自チームでない、もしくは自チームの他投手のデータ閲覧権限がある
            let query = {
                team_id: teamID,
                pitching: 1,
                'date-before': this.year + '-12-31',
                'date-after': this.year + '-01-01'
            }
            API.GAMES.ROSTERS.SUMMARY.getIndex(query,
                (json) => {
                    let rosters = []
                    let hasSelectedPlayer = false
                    json.forEach((d) => {
                        const uid = d.player.split('@')[0]
                        const player = players[uid]
                        if (player) {
                            if (this.existsPlayer(this.year, teamID, player)) {
                                rosters.push(player)
                                if (this.formSelectPlayer === uid) {
                                    hasSelectedPlayer = true
                                }
                            }
                        }
                    })
                    this.filteredRoster = rosters
                    if (hasSelectedPlayer) {
                        this.checkSelectPlayer()
                        this.getGameList()
                    }
                },
                (error) => {
                    common.LOG('ERROR', '3D軌跡 比較モード トップ', 'getRosterList', JSON.stringify(error))
                }
            )

        },
        // 選択した投手の登板した試合を取得
        getGameList () {
            //console.log('getGameList')
            let options = {
                pitching: 1,
                'date-before': this.year + '-12-31',
                'date-after': this.year + '-01-01'
            }
            this.sortedListOfStadiums = []
            API.TEAMS.PLAYERS.GAMES.getIndex(this.formSelectTeam, this.formSelectPlayer, options, (json) => {
                // success
                //console.log('getGameList取得成功', json)
                // 取得した試合一覧のフォーマットを整形（年をキーにしたオブジェクト形式に）
                if (json.length === 0) {
                    return
                }
                let tmpObj = {}
                json.sortBy('date')
                let minDate = json.first().date
                let maxDate = json.last().date
                for (let i = 0, len = json.length; i < len; i++) {
                    let tmpYear = this.$d(json[i].date).format('YYYY')
                    if (!(tmpYear in tmpObj)) {
                        tmpObj[tmpYear] = []
                    }
                    // 対戦チーム名
                    let vsTeam = ''
                    if (this.formSelectTeam === json[i].awayteam_id) {
                        vsTeam = json[i].hometeam_id
                    } else {
                        vsTeam = json[i].awayteam_id
                    }
                    json[i]['vsTeamID'] = vsTeam
                    json[i]['vsTeam'] = this.listOfTeamsLS[vsTeam].name_short
                    json[i]['vsTeamFull'] = this.listOfTeamsLS[vsTeam].name
                    tmpObj[tmpYear].push(json[i])
                    // スタジアム選択用
                    if (this.sortedListOfStadiums.indexOf(json[i].stadium) < 0) {
                        this.sortedListOfStadiums.push(json[i].stadium)
                    }
                }
                tmpObj['minDate'] = minDate
                tmpObj['maxDate'] = maxDate
                this.formSelectDate = [this.$d(minDate).format('YYYY年MM月DD日'), this.$d(maxDate).format('YYYY年MM月DD日')]
                this.formDategameSchedule = Object.assign({}, tmpObj)
                if (this.formSelectStadium && !this.sortedListOfStadiums.includes(this.formSelectStadium)) {
                    this.formSelectStadium = ''
                }
            }, (error) => {
                // error
                console.log('getGameList取得失敗', error)
                common.LOG('ERROR', '3D軌跡 比較モード トップ', 'getGameList', JSON.stringify(error))
            })
        },
        // 比較球検索（指定した球種の球数）
        getBallCount () {
            // 球種の指定がない場合はそのまま全球数取得
            if (this.formSelectBall === '') {
                this.getBallCountAll(0)
                return false
            }
            // 球種の指定がある場合はその球種の球数を取得
            let query = {
                'date-after': this.$d(this.formSelectDate[0]).format('YYYY-MM-DD'),
                'date-before': this.$d(this.formSelectDate[1]).format('YYYY-MM-DD'),
                'pitcher': this.formSelectPlayer + '@' + this.formSelectTeam,
                'pitchingdata': {
                    'TaggedPitchType': this.formSelectBall
                },
                'limit': 1,
                he_first: true
            }
            if (this.formSelectType === 1) {
                query.level = 'Bullpen'
            }
            // console.log('getPitchesMulti', query
            API.PITCHES.getIndex(query,
                (json, status, headers) => {
                    this.getBallCountAll(headers.get('x-page-count'))
                },
                (error) => {
                    console.log('getBallCount取得失敗', error)
                    common.LOG('ERROR', '3D軌跡 比較モード トップ', 'getBallCount', JSON.stringify(error))
                }
            )
        },
        // 比較球検索（全球の球数）
        getBallCountAll (selectBallCount) {
            // 球数の取得
            let query = {
                'date-after': this.$d(this.formSelectDate[0]).format('YYYY-MM-DD'),
                'date-before': this.$d(this.formSelectDate[1]).format('YYYY-MM-DD'),
                'pitcher': this.formSelectPlayer + '@' + this.formSelectTeam,
                'limit': 1,
                he_first: true
            }
            if (this.formSelectType === 1) {
                query.level = 'Bullpen'
            }
            // console.log('getPitchesMulti', query)
            API.PITCHES.getIndex(query,
                (json, status, headers) => {
                    if (headers.get('x-page-count') > 3000) {
                        this.$root.$emit('messageModalOn', "抽出できる件数を超えました。<br>再度条件を変更してお試しください。")
                        return
                    }
                    if (headers.get('x-page-count') >= 300) {
                        if (selectBallCount > 0) {
                            this.loadingOn(selectBallCount + '球のデータを取得しています。<br>表示されるまで少々お待ち下さい。')
                        } else {
                            this.loadingOn(headers.get('x-page-count') + '球のデータを取得しています。<br>表示されるまで少々お待ち下さい。')
                        }
                    } else {
                        this.loadingOn()
                    }
                    this.formSubmitCompareBall()
                },
                (error) => {
                    console.log('getBallCount取得失敗', error)
                    common.LOG('ERROR', '3D軌跡 比較モード トップ', 'getBallCountAll', JSON.stringify(error))
                }
            )
        },
        formSubmitCompareBall () {
            let query = {
                'date-after': this.$d(this.formSelectDate[0]).format('YYYY-MM-DD'),
                'date-before': this.$d(this.formSelectDate[1]).format('YYYY-MM-DD'),
                'pitcher': this.formSelectPlayer + '@' + this.formSelectTeam,
                'limit': 5000,
                he_first: true
            }
            if (this.formSelectType === 1) {
                query.level = 'Bullpen'
            }
            if (this.searchModalType === 'standard') {
                common.LOG('INFO', '3D軌跡 比較モード トップ', '基準球 検索', JSON.stringify(query))
            } else {
                common.LOG('INFO', '3D軌跡 比較モード トップ', '比較球 検索', JSON.stringify(query))
            }
            API.PITCHES.getIndex(query,
                (json) => {
                    if (json.length === 0) {
                        this.loadingOff()
                        this.messageModalOn('指定した試合期間の投球データがありません。')
                    } else {
                        // this.mostFastBall = this.Caluate.getMostFastBall(json)
                        let tmpData = json.filter((d) => d.pitchingdata !== null).map((d,i)=>{
                            if (d.pitchingdata) {
                                if (d.pitchingdata.TaggedPitchType === 'FourSeamFastball') {
                                    d.pitchingdata.TaggedPitchType = 'Fastball'
                                }
                                if (d.pitchingdata.TaggedPitchType === 'OneSeamFastball') {
                                    d.pitchingdata.TaggedPitchType = 'TwoSeamFastball'
                                }
                                if (['FoulBallNotFieldable','FoulBallFieldable'].includes(d.pitchingdata.PitchCall)) {
                                    d.pitchingdata.PitchCall = 'FoulBall'
                                }
                            }
                            d.pitchofpa = Number(d.pitchofpa)
                            return d
                        })
                        const resHandler = (res) => {
                            this.formatComparePitchingData(res)
                        }
                        Calculate.getMostFastBall(tmpData, resHandler, this)
                        // this.formatComparePitchingData(json)
                        // this.ballsOfCompare = json
                        // this.searchState = 1
                    }
                },
                (error) => {
                    // console.log(json, this)
                    this.loadingOff()
                    common.LOG('ERROR', '3D軌跡 比較モード トップ', 'formSubmitCompareBall', JSON.stringify(error))
                }
            )
        },
        formatComparePitchingData (res) {
            // console.log('formatComparePitchingData', res)
            const balls = res.defaultBalls
            const compareBalls = []
            this.mostFastBall = res.mostFastBall
            this.savedBasllsId = this.currentSavedBallsId
            this.savedStandardBasllsId = this.currentSavedStandardBallId

            const avgSpeed = this.mostFastBall.ave_speed
            const hitTypeMap = setting.typesOfHitType
            const ballTypeMap = setting.typesOfBall
            const playResultMap = setting.typesOfPlayResult
            const searchKorBBMap = this.typesOf3DSearchKorBB
            const searchPitchCallMap = this.typesOf3DSearchPitchCall

            balls.forEach((d) => {
                const pd = d.pitchingdata
                if (this.formSelectStadium !== '' && this.formSelectStadium !== pd['Stadium']) {
                    return
                }
                const tmpData = {
                    id: d['id'],
                    original: d,
                    data: {
                        'Date': pd['Date'],
                        'pitchno': Number(d['pitchno']),
                        'HitType': {
                            id: pd.HitType,
                            name: hitTypeMap.hasOwnProperty(pd.HitType) ? hitTypeMap[pd.HitType].name : '―'
                        }
                    }
                }

                const batter = this.$p.get(pd.BatterTeam)[pd.BatterId]
                if (this.formSelectType === 0) {
                    tmpData.data['BatterTeamId'] = pd.BatterTeam
                    tmpData.data['BatterTeamName'] = this.listOfTeamsLS[pd.BatterTeam].name_short2
                    tmpData.data['BatterId'] = pd.BatterId
                    tmpData.data['BatterName'] = batter?.name ?? pd.BatterId + '@' + pd.BatterTeam
                } else {
                    tmpData.data['BatterTeamId'] = ''
                    tmpData.data['BatterTeamName'] = '-'
                    tmpData.data['BatterId'] = ''
                    tmpData.data['BatterName'] = '-'
                }

                let resultId = ''
                let resultName = '―'

                // 判定結果振り分け インプレイ
                if (pd.PitchCall === 'InPlay') {
                    resultId = pd.PlayResult
                    resultName = playResultMap[pd.PlayResult]?.name ?? '―'
                    // 判定結果振り分け インプレイ以外の三振、四球
                } else if (pd['KorBB'] !== 'Undefined') {
                    if (pd['KorBB'] === 'Strikeout') {
                        if (pd.PitchCall === 'StrikeSwinging') {
                            resultId = 'StrikeoutSwinging'
                            resultName = '三振（空振り）'
                        } else if (pd.PitchCall === 'StrikeCalled') {
                            resultId = 'StrikeoutCalled'
                            resultName = '三振（見逃し）'
                        }
                    } else {
                        resultId = pd['KorBB']
                        resultName = searchKorBBMap[pd['KorBB']]?.name ?? '-'
                    }
                    // 判定結果振り分け インプレイ以外の空振りストライク、見逃しストライク、ファール、ボール、デッドボール
                } else if (pd.PitchCall !== 'Undefined') {
                    if (pd.PitchCall === 'StrikeSwinging') {
                        if (pd['Zone'] === 'Zone') {
                            resultId = 'StrikeSwingingZone'
                            resultName = '空振ストライク（ゾーン内）'
                        } else {
                            resultId = 'StrikeSwingingO-Zone'
                            resultName = '空振ストライク（ゾーン外）'
                        }
                    } else if (pd.PitchCall === 'HitByPitch') {
                        resultId = 'BallCalledHitByPitch'
                        resultName = 'デッドボール'
                    } else {
                        resultId = pd.PitchCall
                        resultName = searchPitchCallMap[pd.PitchCall]?.name ?? pd.PitchCall
                    }
                }
                tmpData.data.result = {
                    id: resultId,
                    name: resultName
                }

                tmpData.data['checkPitchCall'] = pd.PitchCall
                tmpData.data['checkZone'] = pd['Zone']
                tmpData.data['TaggedPitchType'] = ballTypeMap[pd.TaggedPitchType]?.name ?? pd.TaggedPitchType
                tmpData.data['AlphaTaggedPitchType'] = pd.TaggedPitchType
                tmpData.data['RelSpeed'] = Math.round(pd['RelSpeed'] / 1000)
                tmpData.data['RelSpeed_Per'] = Math.round(((pd['RelSpeed'] / 1000) * 100) / avgSpeed)

                tmpData.data['SpinRate'] = pd['SpinRate'] !== null ? Math.round(pd['SpinRate']) : '―'
                tmpData.data['Rifle'] = pd['Rifle'] !== null ? Math.round(pd['Rifle']) : '―'
                tmpData.data['w_sin_a'] = pd['w_sin_a'] !== null ? Math.round(pd['w_sin_a']) : '―'

                tmpData.data['InducedVertBreak'] = Math.round(pd['InducedVertBreak'] * 100)
                tmpData.data['HorzBreak'] = Math.round(pd['HorzBreak'] * 100)
                tmpData.data['DeflectionAngle'] = Math.round(pd['DeflectionAngle'])
                tmpData.data['Depth'] = Math.round(pd['Depth'] * 100)
                tmpData.data['RelHeight'] = Math.round(pd['RelHeight'] * 100)
                tmpData.data['RelSide'] = Math.round(pd['RelSide'] * 100)
                tmpData.data['Extension'] = Math.round(pd['Extension'] * 100)
                tmpData.data['AtBat'] = pd['PA'] ?? '-'

                compareBalls.push(tmpData)
            })
            this.loadingOff()
            this.defaultBalls = compareBalls
            this.allBallNumber = compareBalls.length
            this.ballsOfCompare = compareBalls
            this.searchState = 1
        },
        // 比較球に追加、削除
        addCompareBall (addBall) {
            const pitcher = this.$p.get(addBall.original.pitchingdata.PitcherTeam)[addBall.original.pitchingdata.PitcherId]
            const batter = this.$p.get(addBall.original.pitchingdata.BatterTeam)[addBall.original.pitchingdata.BatterId]
            console.log('addCompareBall', pitcher, batter)
            const ball = {
                id: addBall.original.id,
                gameId: addBall.original.game_id,
                inning: addBall.original.inning,
                paofinning: addBall.original.paofinning,
                pitchofpa: addBall.original.pitchofpa,
                pitcher: {
                    id: addBall.original.pitchingdata.PitcherId,
                    uniform_number: pitcher.additional?.uniform_number ?? '999',
                    name: pitcher.name
                },
                team: {
                    id: addBall.original.pitchingdata.PitcherTeam,
                    name: this.listOfTeamsLS[addBall.original.pitchingdata.PitcherTeam].name_short2
                },
                batter: {
                    id: addBall.original.pitchingdata.BatterId,
                    uniform_number: batter.additional?.uniform_number ?? '999',
                    name: batter.name
                },
                vsTeam: {
                    id: addBall.original.pitchingdata.BatterTeam,
                    name: this.listOfTeamsLS[addBall.original.pitchingdata.BatterTeam].name_short2
                },
                data: addBall.original,
                ballColor: '#ffffff',
                enabled: true,
                ballType: 'compare'
            }
            let duplicate = false
            let data = ball
            let savedBalls = this.$ls.get('savedBalls',[])
            if (savedBalls.length >= 20) {
                this.messageModalOn('比較球が20球登録されています。')
                return
            }
            let duplicateIndex = -1
            savedBalls.forEach((d, i) => {
                if (d.data.id === data.data.id) {
                    duplicate = true
                    duplicateIndex = i
                }
            })
            if (duplicate) {
                savedBalls.splice(duplicateIndex, 1)
                this.$ls.set('savedBalls', savedBalls)
                this.getSavedBalls()
                this.$alert('投球を比較リストから削除しました。')
                this.savedBasllsId.splice(duplicateIndex, 1)
                common.LOG('INFO', '3D軌跡 比較モード トップ', '比較球 削除', ball.id, pitcher.name)
            } else {
                data = savedBalls.concat(data)
                this.$ls.set('savedBalls', data)
                this.getSavedBalls()
                this.$alert('投球を比較リストに追加しました。')
                this.savedBasllsId.push(ball.id)
                common.LOG('INFO', '3D軌跡 比較モード トップ', '比較球 追加', ball.id, pitcher.name)
            }
        },
        // 基準球に設定、解除
        addStandardBall (addBall) {
            const pitcher = this.$p.get(addBall.original.pitchingdata.PitcherTeam)[addBall.original.pitchingdata.PitcherId]
            const batter = this.$p.get(addBall.original.pitchingdata.BatterTeam)[addBall.original.pitchingdata.BatterId]
            let ball = {
                id: addBall.original['id'],
                gameId: addBall.original['game_id'],
                inning: addBall.original['inning'],
                paofinning: addBall.original['paofinning'],
                pitchofpa: addBall.original['pitchofpa'],
                pitcher: {
                    id: addBall.original.pitchingdata.PitcherId,
                    uniform_number: pitcher.additional?.uniform_number ?? '999',
                    name: pitcher.name
                },
                team: {
                    id: addBall.original.pitchingdata.PitcherTeam,
                    name: this.listOfTeamsLS[addBall.original.pitchingdata.PitcherTeam].name_short2
                },
                batter: {
                    id: addBall.original.pitchingdata.BatterId,
                    uniform_number: batter.additional?.uniform_number ?? '999',
                    name: batter.name
                },
                vsTeam: {
                    id: addBall.original.pitchingdata.BatterTeam,
                    name: this.listOfTeamsLS[addBall.original.pitchingdata.BatterTeam].name_short2
                },
                data: addBall.original,
                ballColor: '#ff0000',
                enabled: true,
                ballType: 'standard'
            }
            let duplicate = false
            let data = ball
            let savedBalls = this.$ls.get('savedStandardBalls')
            savedBalls.forEach((d) => {
                if (d.data.id === data.data.id) {
                    duplicate = true
                }
            })
            if (duplicate) {
                savedBalls = []
                this.$ls.set('savedStandardBalls', savedBalls)
                this.getSavedStandardBalls()
                this.$alert('基準球を解除しました。')
                this.savedStandardBasllsId = []
                common.LOG('INFO', '3D軌跡 比較モード トップ', '基準球 解除', ball.id, ball.pitcher.name)
            } else {
                data = [].concat(data)
                this.$ls.set('savedStandardBalls', data)
                this.getSavedStandardBalls()
                this.$alert('基準球を設定しました。')
                this.savedStandardBasllsId = []
                this.savedStandardBasllsId.push(ball.id)
                common.LOG('INFO', '3D軌跡 比較モード トップ', '基準球 設定', ball.id, ball.pitcher.name)
            }
        },
        getSavedBalls () {
            this.$emit('get-saved-balls')
        },
        getSavedStandardBalls () {
            this.$emit('get-saved-standard-balls')
        },
        completeAndUpdate () {
            this.$emit('close-search-modal')

            // フィルター条件をリセット
            this.filterSelectDate = ''
            this.formSelectBall = ''
            this.filterSelectHittype = ''
            this.filterSelectResult = ''
            this.filterSelectVsTeam = ''
            this.filterSelectVsBatter = ''
            this.filterSelectAtBat = ''
            this.searchState = 0

            window.setTimeout(() => {
                this.$emit('update-all')
            }, 200)
        },
        checkSelectPlayer () {
            this.isValidateList.player = this.formSelectPlayer !== ''
            this.checkValidate()
        },
        checkSelectDate () {
            this.isValidateList.date = this.formSelectDate[0] !== '' && this.formSelectDate[1] !== ''
            this.checkValidate()
        },
        checkValidate () {
            let valid = true
            let count = 0
            Object.keys(this.isValidateList).forEach((d) => {
                if (!this.isValidateList[d]) {
                    count++
                }
            })
            if (count === 0) {
                valid = false
            }
            this.isValidate = valid
        },
        changedYear (year) {
            if (year && this.formSelectTeam) {
                this.getRosterList(this.formSelectTeam)
                if (this.formSelectPlayer) {
                    this.getGameList()
                }
            }
        }
    }
}
</script>
